// FILECONTENT_START src/common/components/Card/index.ts
import Card from "./Card";
export default Card;
export type { CardProps } from "./Card";

// FILECONTENT_END src/common/components/Card/index.ts